export class Observable {
  constructor(value) {
    this._value = value;
    this._observers = [];
    this._dataReadyObservers = [];
  }

  get value() {
    return this._value;
  }

  set value(newValue) {
    if (JSON.stringify(this._value) !== JSON.stringify(newValue)) {
      this._value = newValue;
      this._notifyDataReadyObservers();
      this._notifyObservers();
    }
  }

  _notify() {
    for (const callback of this._observers) {
      callback(this._value);
    }
  }

  removeObserver(callback) {
    this._observers = this._observers.filter((obs) => obs !== callback);
  }

  addObserver(callback) {
    if (typeof callback === 'function') {
      if (this._value) callback(this._value);
      this._observers.push(callback);
    }
  }

  addOnDataReady(callback) {
    if (typeof callback === 'function') {
      if (this._value) {
        callback(this._value);
      } else {
        this._dataReadyObservers.push(callback);
      }
    }
  }

  _notifyObservers() {
    for (const callback of this._observers) {
      callback(this._value);
    }
  }

  _notifyDataReadyObservers() {
    while (this._dataReadyObservers.length > 0) {
      const callback = this._dataReadyObservers.shift();
      callback(this._value);
    }
  }
}
